import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Wrapper = styled.div`
  position: relative;
  margin: 0 0 8px;
`;

export const Shadow = styled.span`
  position: absolute;
  display: block;
  visibility: hidden;
  z-index: -1;
`;

export const Label = styled.label`
  margin: 0 0 6px;
  padding: 0 4px;
  height: 16px;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  transition: height 0.2s ease-in-out;

  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;

  &.focus {
    -webkit-line-clamp: unset;
    -webkit-box-orient: unset;
    display: block;
    overflow: unset;
    text-overflow: unset;
  }
`;

export const InputBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 48px;
  overflow: hidden;
  border: 2px solid ${vars.v3Color.gray100};
  border-radius: 8px;
  background: #fff;

  &.focus {
    border: 2px solid ${vars.v3Color.gray200};
  }
`;

export const Input = styled.input`
  max-width: 320px;
  width: 100%;
  height: 100%;
  padding: 13px 0 13px 16px;
  line-height: inherit;
  font-size: 16px;
  font-weight: 600;

  &::placeholder {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    vertical-align: middle;
    color: ${vars.v3Color.gray300};
  }
`;

export const valueLength = css`
  padding: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 54px;
  height: 100%;
`;
